import type { Amplitude } from '@app/services/Amplitude'

import { createThunk } from '@app/store/thunk'

export function getAmplitude() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<Amplitude>(AmplitudeSymbol))
}
export function setAmplitude(value: Amplitude) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(AmplitudeSymbol, value))
}

const AmplitudeSymbol = Symbol('Amplitude')
